// JavaScript - показывать cookie-баннер при каждом посещении
document.addEventListener('DOMContentLoaded', function() {
  const cookieConsent = document.getElementById('cookie-consent');
  const cookieAccept = document.getElementById('cookie-accept');

  // НЕ проверяем localStorage, всегда показываем баннер
  // с небольшой задержкой для лучшего UX
  setTimeout(() => {
    cookieConsent.classList.add('show');
  }, 1000);

  // Принять cookie (только скрывает на этой вкладке)
  cookieAccept.addEventListener('click', function() {
    hideCookieBanner();
  });

  // Закрытие по клику вне баннера (опционально)
  document.addEventListener('click', function(e) {
    if (!cookieConsent.contains(e.target) && cookieConsent.classList.contains('show')) {
      hideCookieBanner();
    }
  });

  // Закрытие по ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cookieConsent.classList.contains('show')) {
      hideCookieBanner();
    }
  });

  // Скрыть баннер cookie
  function hideCookieBanner() {
    cookieConsent.classList.remove('show');
    // Не удаляем элемент, чтобы можно было показать снова
  }

  // Можно добавить автоскрытие через N секунд (опционально)
  // setTimeout(() => {
  //   if (cookieConsent.classList.contains('show')) {
  //     hideCookieBanner();
  //   }
  // }, 15000); // Автоскрытие через 15 секунд
});
